import Funds from './Funds/Funds';

export const PortfolioBuilderForms = {
  Funds
};
